import { render, staticRenderFns } from "./ReleaseResourceModal.vue?vue&type=template&id=b0b6790e&scoped=true&"
import script from "./ReleaseResourceModal.vue?vue&type=script&lang=js&"
export * from "./ReleaseResourceModal.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseResourceModal.vue?vue&type=style&index=0&id=b0b6790e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b6790e",
  null
  
)

export default component.exports